const HeroPrimary = (props) => {

  const {
    preTitle,
    title,
    paragraph,
    ctaPrimary,
    ctaSecondary,
    image,
    colorScheme = 'darkGreen'
  } = props

  const normalizedData = {
    pretitle: preTitle,
    title,
    paragraph,
    ctaPrimary,
    ctaSecondary,
    image: {
      alt: image.alternativeText,
      src: image.url
    },
    colorScheme
  }

  return normalizedData
}

export default HeroPrimary
